"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUrlOfExperiment = exports.getExperimentPath = exports.isValidScopeUrl = exports.getAllInScopePath = exports.petriUrlMap = void 0;
exports.petriUrlMap = {
    new: {
        conductAllInScope: '/_api/wix-laboratory-server/v1/laboratory/platform/conductAllInScope',
        conductExperiment: '/_api/wix-laboratory-server/v1/laboratory/platform/conductExperiment',
    },
    old: {
        conductAllInScope: '/_api/wix-laboratory-server/laboratory/conductAllInScope',
        conductExperiment: '/_api/wix-laboratory-server/laboratory/conductExperiment',
    },
};
exports.getAllInScopePath = function (scope, useNewApi) {
    if (scope === void 0) { scope = ''; }
    if (useNewApi === void 0) { useNewApi = false; }
    var urlApi = useNewApi
        ? exports.petriUrlMap.new.conductAllInScope + "?scope=" + encodeURIComponent(scope)
        : exports.petriUrlMap.old.conductAllInScope + "?scope=" + encodeURIComponent(scope);
    return urlApi;
};
function isValidScopeUrl(url, useNewApi) {
    return (url.indexOf(useNewApi
        ? exports.petriUrlMap.new.conductAllInScope
        : exports.petriUrlMap.old.conductAllInScope) !== -1);
}
exports.isValidScopeUrl = isValidScopeUrl;
exports.getExperimentPath = function (key, fallback, useNewApi) {
    if (key === void 0) { key = ''; }
    if (fallback === void 0) { fallback = ''; }
    if (useNewApi === void 0) { useNewApi = false; }
    var urlApi = useNewApi
        ? exports.petriUrlMap.new.conductExperiment + "?key=" + encodeURIComponent(key) + "&fallbackValue=" + encodeURIComponent(fallback)
        : exports.petriUrlMap.old.conductExperiment + "?key=" + encodeURIComponent(key) + "&fallback=" + encodeURIComponent(fallback);
    return urlApi;
};
function isUrlOfExperiment(url, specName, useNewApi) {
    var pattern = "" + exports.getExperimentPath(specName, '', useNewApi);
    return url.includes(pattern);
}
exports.isUrlOfExperiment = isUrlOfExperiment;
//# sourceMappingURL=urlMap.js.map